import React, { useEffect, useState } from 'react';
import { useField } from 'react-final-form';
import { fetchIditIds } from '../SDL/iditMap';

export default function HiddenInput({ name, value, fieldId }) {
    const field = useField(name, { initialValue: value });

    const [iditIdsStstMap, setIditIdsStstMap] = useState(new Map());

    useEffect(() => {
        if (name === 'forbund') {
            const fetchIds = async () => {
                const iditIds = await fetchIditIds();
                setIditIdsStstMap(iditIds);
            };
            fetchIds();
        }
    }, []);

    if (name === 'forbund' && iditIdsStstMap?.has(value)) {
        const groupId = iditIdsStstMap.get(value)?.groupId;
        const groupAgreementId = iditIdsStstMap.get(value)?.groupAgreementId;

        return (
            <>
                <input type={`hidden`} {...field.input} name={name} value={value} id={fieldId} />
                <input type={`hidden`} name="groupId" value={groupId} id={'groupId'} />
                <input type={`hidden`} name="groupAgreementId" value={groupAgreementId} id={'groupAgreementId'} />
            </>
        );
    }

    return <input type={`hidden`} {...field.input} name={name} value={value} id={fieldId} />;
}
